import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as notifiactionType from '../../const/Notifications';

const Notification = (props) => {
    if (props.notification.type) {
        const notifiactionClassName = classNames(
            "col-xs-12",
            "alert",
            "fade in",
            {"alert-info": props.notification.type===notifiactionType.INFO_NOTIFICATION},
            {"alert-success": props.notification.type===notifiactionType.SUCCESS_NOTIFICATION},
            {"alert-warning": props.notification.type===notifiactionType.WARNING_NOTIFICATION},
            
        );
        return(
            <div className={notifiactionClassName}>
                <button 
                    type="button" 
                    className="close" 
                    onClick={props.onCloseButtonClick}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <strong>{props.notification.title}</strong> 
                <br/>
                {props.notification.message}
            </div>
        );
    }
    return null;
};

Notification.propTypes = {
    notification: PropTypes.shape({
        type: PropTypes.oneOf[
            notifiactionType.INFO_NOTIFICATION,
            notifiactionType.SUCCESS_NOTIFICATION,
            notifiactionType.WARNING_NOTIFICATION
        ],
        title: PropTypes.string,
        message: PropTypes.string
    }),
    onCloseButtonClick: PropTypes.func
};

export default Notification;


// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js